import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';

import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import GLOBAL_FILTER_CONTROLLER from '../../controllers/globalFilter';
import LANGUAGE_CONTROLLER from '../../controllers/languages';
import GlobalFilterPanel, { FILTER_PERIOD_GROUP, FIELDS as GLOBAL_FILTER_FIELDS } from '../filter/GlobalFilterPanel';
import SingleCurrencySelector from '../selectors/currency/SingleCurrencySelector';

import Logger, {LOG_LEVELS} from '../../utils/logger';
import ReactComponentHelper from '../helper/ReactComponentHelper';
import moment from 'moment';
const log = new Logger('EXCHANGE_RATES_FILTER_PANEL', LOG_LEVELS.DEBUG);

export const ALL_CURRENCY_KEY = 'exchangeRatesFilterPanel_allCurrencies';

export class ExchangeRatesFilterPanel extends React.Component {

    constructor(props) {
        super(props);
        log.debug('constructor(): ExchangeRatesFilterPanel: ', props);
        this.onSearchClickHandler = this.onSearchClickHandler.bind(this);
        this.selectionHandler = this.selectionHandler.bind(this);
        this.allCurrenciesItem =  {
            countryCode: 'ALL_COUNTRIES',
            currencyCode: LANGUAGE_CONTROLLER.format(this.props.languages, ALL_CURRENCY_KEY)
        };
        this.currencyList = ReactComponentHelper.getCurrencies(this.allCurrenciesItem);
        this.state = {
            selection: {}
        };
    }

    onSearchClickHandler(selection) {
        log.debug('onSearchClickHandler(): selection: ', selection);
        const combinedSelection = Object.assign({}, selection, this.state.selection);
        log.debug('onSearchClickHandler(): combinedSelection: ', combinedSelection);
        this.props.onSearchClick(combinedSelection);
    }

    selectionHandler(keyValuePairs) {
        log.debug('selectionHandler() Key value pairs: ', keyValuePairs);    
        let key =  Object.keys(keyValuePairs)[0];
        let value =  Object.values(keyValuePairs)[0];
        let selection = Object.assign({}, this.state.selection);
        if(_.isEmpty(value)) {
          delete selection[key];
        } else {
          selection = Object.assign(selection, keyValuePairs);
        }
        this.setState({
          selection: selection
        });
    }

    componentDidMount() {                
        let filterOptions = this.props.filterOptions;
        log.debug('componentDidMount() - filterOptions: ', this.props.filterOptions);        
        if(filterOptions) {
            let selection = {
                fromCurrency: filterOptions.fromCurrency || this.allCurrenciesItem.currencyCode,
                toCurrency: filterOptions.toCurrency || this.allCurrenciesItem.currencyCode
            };
            this.setState({
                selection: selection
            });
        }
    }

    render () {
        log.debug('render(): ', this.props);
        const globalSelection = GLOBAL_FILTER_CONTROLLER.getAll();
        const selection = Object.assign({}, globalSelection, this.state.selection);
        const disableSearch = (filterSelection) => {
            let disable = false;
            if(_.isEmpty(filterSelection.startDate) || _.isEmpty(filterSelection.endDate) || _.isEmpty(selection.fromCurrency) || _.isEmpty(selection.toCurrency)) {
                disable = true;
            } else {
                disable = moment.utc(filterSelection.endDate).isBefore(moment.utc(filterSelection.startDate));
            }
            return disable;
        };
        let hiddenElements = {};
        hiddenElements[GLOBAL_FILTER_FIELDS.PARAM_MONTH] = true;
        hiddenElements[GLOBAL_FILTER_FIELDS.PARAM_YEAR] = true;
        hiddenElements[GLOBAL_FILTER_FIELDS.PARAM_COMPANY_ID] = true;
        hiddenElements[GLOBAL_FILTER_FIELDS.PARAM_COUNTRY_CODE] = true;
        hiddenElements[GLOBAL_FILTER_FIELDS.PARAM_RETURN_STATUS] = true;
        hiddenElements[GLOBAL_FILTER_FIELDS.PARAM_RETURN_TYPE] = true;

        let elementsLabel = {};
        elementsLabel[GLOBAL_FILTER_FIELDS.PARAM_START_DATE] = 'exchangeRatesFilterPanel_dateFrom';
        elementsLabel[GLOBAL_FILTER_FIELDS.PARAM_END_DATE] = 'exchangeRatesFilterPanel_dateTo';

        return (
            <s-box name="filter-panel" data-test="component-exchange-rates-filter-panel">
                <GlobalFilterPanel 
                    filterPeriodGroup={FILTER_PERIOD_GROUP.DATE_RANGE} 
                    disableSearch={disableSearch} 
                    skipAtLeastOneRequiredCheck={true}
                    hideElements={hiddenElements}
                    onSearchClick={this.onSearchClickHandler}
                    adaptPeriodOptions={ { fallbackToStartDate: true } }
                    labelElements= {elementsLabel}
                >
                    <fieldset>
                        <label className="mr20" data-test="label-from-currency"><LanguageStringResolver string='exchangeRatesFilterPanel_fromCurrency' /></label>
                        <SingleCurrencySelector fieldName="fromCurrency" value={selection.fromCurrency} onChange={this.selectionHandler} currencyList={this.currencyList} />
                    </fieldset>
                    <fieldset>
                        <label className="mr20" data-test="label-to-currency"><LanguageStringResolver string='exchangeRatesFilterPanel_toCurrency' /></label>
                        <SingleCurrencySelector fieldName="toCurrency" value={selection.toCurrency} onChange={this.selectionHandler} currencyList={this.currencyList} />
                    </fieldset>
                </GlobalFilterPanel>
                <div className="clear"/>
            </s-box>
        );
    }
}


ExchangeRatesFilterPanel.defaultProps = {
    onSearchClick: () => {},
    filterOptions: {}
}

function mapStateToProps(state) {
    return {
        languages: state.languages
    }
}

export default connect(mapStateToProps)(ExchangeRatesFilterPanel) ;
